import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import LoginView from '../views/LoginView.vue';
import HomeView from '../views/HomeView.vue';
import JobMap from "../components/JobMap.vue";

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { hideNavbar: true } ,
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userPermissions');
      next({ name: 'login' });
    }
  },
  {
    path: "/map",
    name: "JobMap",
    component: JobMap,
    meta: { requiresAuth: true, requiredPermissions: [] }
  },
  { path: '/reset_password',
    name: 'reset_password',
    component: () => import('../components/PasswordReset.vue'),  
  },
  { path: '/reset-password-confirm', 
    component: () => import('../components/PasswordResetConfirm.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true, requiredPermissions: [] }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { requiresAuth: false, requiredPermissions: [] }
  },
  {
    path: '/contracts',
    name: 'contracts',
    component: () => import('../views/ContractView.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_contract'] }
  },
  {
    path: '/contract-form',
    name: 'contract-form',
    component: () => import('../components/ContractFormComponent.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.add_contract'] }
  },
  {
    path: '/contract-edit/edit/:id',
    name: 'contract-edit',
    component: () => import('../components/ContractFormComponent.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.change_contract'] }
  },
  {
    path: '/contract-view/view/:id',
    name: 'contract-view',
    component: () => import('../components/ContractFormComponent.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_contract'] }
  },
  {
    path: '/work-prices',
    name: 'work-prices',
    component: () => import('../views/WorkPricesView.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_workprice'] }
  },
  {
    path: '/work-prices-form',
    name: 'work-prices-form',
    component: () => import('../components/WorkPriceFormComponent.vue'),
    props: true,
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.add_workprice'] }
  },
  {
    path: '/work-prices/edit/:id',
    name: 'work-prices-edit',
    component: () => import('../components/WorkPriceFormComponent.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.change_workprice'] }
  },
  {
    path: '/work-prices/view/:id',
    name: 'work-prices-view',
    component: () => import('../components/WorkPriceFormComponent.vue'),
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_workprice'] }
  },
  {
    path: '/contract-pdf/:id',
    name: 'contract-pdf',
    component: () => import('../components/ContractPDFGenerator.vue'),
    props: true, 
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_contract'] }
  },
  {
    path: '/weekly-summary-list/',
    name: 'weekly-summary-list',
    component: () => import('../components/WeeklySummaryListComponent.vue'),
    props: true, 
    meta: { requiresAuth: true, requiredPermissions: ['ctrctsapp.view_contract'] }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authToken = localStorage.getItem('authToken');
  console.log(`Auth Token in Router>>: ${authToken ? 'true' : 'false'}`);
  const userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');
  //console.log(`User Permissions in Router>>: ${JSON.stringify(userPermissions)}`);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authToken) {
      next({ name: 'login' });
    } else {
      try {
        const response = await axios.get('/api/validate-token/', {
          headers: { 'Authorization': `Token ${authToken}` }
        });
        
        if (response.data.valid) {
          const requiredPermissions = to.meta.requiredPermissions || [];
          const userPermissionsArray = userPermissions.permissions || [];
          const userPermissionsSet = new Set(userPermissionsArray);
          
          const hasPermission = requiredPermissions.length === 0 || 
            requiredPermissions.every(permission => userPermissionsSet.has(permission));
          console.log('Has permission:', hasPermission);

          if (hasPermission) {
            next();
          } else {
            alert('You do not have permission to access this page');
            next(false);
          }
        } else {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userPermissions');
          next({ name: 'login' });
        }
      } catch (error) {
        console.error('Error validating token:', error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userPermissions');
        next({ name: 'login' });
      }
    }
  } else {
    next();
  }
});

export default router;